import { useRouteLoaderData } from 'react-router';
import { Induction } from './onboarding';
import type { RootLoaderData } from '../lib/types';

/**
 * The same engine as the induction, in edit mode: panels can be jumped between,
 * and finishing returns to the studio instead of running the welcome.
 */
export default function Profile() {
  const { identity, profile } = useRouteLoaderData('root') as RootLoaderData;
  return <Induction identity={identity} profile={profile} mode="edit" />;
}
